import { SignInOptions } from 'next-auth/react';
import { TreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { ActiveSplitExperiment } from 'src/services/experiments/client/ongoingExperiments';
import { PREFIXLESS_ROUTES } from 'src/common/constants';
import { getEnvironmentAppropriateFullDashboardURL } from 'src/utils/getters/getEnvironmentAppropriateFullDashboardURL';
import { setRedirectLocation } from './setRedirectLocation';
import { zillowSignIn } from './zillowSignIn/zillowSignIn';

/**
 * Since multiple components and business logic paths can cause a sign in attempt,
 * it can be difficult to debug why session logins were attempted. To address this, this function
 * requires that a justification for performing a login is provided, which is then logged to the console in lower
 * environments for debugging.
 *
 * Additionally, this function abstracts the logic around ensuring we leverage the required "signin bounce" experience
 * that is aimed at resolving the back-button-breaking-on-authorization-code-flow-pages problem.
 *
 * @param justification - why the session should be started
 */
export const handleSessionStart = (
    justification: string,
    experiments: Record<ActiveSplitExperiment, TreatmentWithConfig | null>,
    signInOptions: SignInOptions = {}
) => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    if (publicRuntimeConfig.isLowerEnvironment) {
        // eslint-disable-next-line no-console
        console.info('Application Session Started - ', justification);
    }

    const signinBouncePage = getEnvironmentAppropriateFullDashboardURL(PREFIXLESS_ROUTES.AUTH_SIGNIN_BOUNCE, {
        useLocal: true,
    });
    if (window.location.pathname !== signinBouncePage) {
        setRedirectLocation(window.location.pathname);
    }

    zillowSignIn(experiments, signInOptions);
};
